import React from 'react';
import {
  FaUserFriends,
  FaClinicMedical,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaVideo,
  FaChartBar,
} from 'react-icons/fa';
import useUserData from '../../hooks/useUserData';
import useHistorico from '../../hooks/useHistorico';
import usePendencias from '../../hooks/usePendencias';
import Shortcut from '../../components/Shortcut';
import TimelineItem from '../../components/TimelineItem';
import CompromissoItem from '../../components/CompromissoItem';

function HomePage() {
  const { user, userPlan } = useUserData();
  const { historico } = useHistorico(user);
  const { pendencias, handleEncerrar } = usePendencias(user);

  const isShortcutDisabled = (route) => {
    if (
      userPlan === 'Gratuito' &&
      (route === 'clinicas' || route === 'relatorios' || route === 'recebiveis')
    ) {
      return true;
    }
    if (userPlan === 'Premium' && route === 'relatorios') {
      return true;
    }
    if (userPlan === 'Premium' && route === 'telemedicina') {
      return true;
    }
    if (userPlan === 'Gratuito' && route === 'telemedicina') {
      return true;
    }
    return false;
  };

  return (
    <main className="min-h-screen bg-gray-100 p-6" data-testid="homepage">
      <header className="mb-8 text-center" data-testid="homepage-header">
        <h2 className="text-3xl font-bold">Bem-vindo ao Plantão Fácil</h2>
        <p className="text-lg text-gray-600">
          Gerencie seus plantões, pacientes e mais de maneira fácil e rápida.
        </p>
      </header>

      <section className="mb-8" data-testid="shortcuts-section">
        <h2 className="font-semibold text-gray-800 mb-4">Atalhos Rápidos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <Shortcut
            to="/atendimento/consultorio"
            icon={<FaClinicMedical size={32} />}
            label="Atendimento"
            data-testid="shortcut-atendimento"
          />
          <Shortcut
            to="/pacientes"
            icon={<FaUserFriends size={32} />}
            label="Pacientes"
            data-testid="shortcut-pacientes"
          />
          <Shortcut
            to="/agenda"
            icon={<FaCalendarAlt size={32} />}
            label="Agenda"
            data-testid="shortcut-agenda"
          />
          <Shortcut
            to="/clinicas"
            icon={<FaClinicMedical size={32} />}
            label="Clínicas"
            disabled={isShortcutDisabled('clinicas')}
            data-testid="shortcut-clinicas"
          />
          <Shortcut
            to="/relatorios"
            icon={<FaChartBar size={32} />}
            label="Relatórios"
            disabled={isShortcutDisabled('relatorios')}
            data-testid="shortcut-relatorios"
          />
          <Shortcut
            to="/recebiveis"
            icon={<FaMoneyBillWave size={32} />}
            label="Recebíveis"
            disabled={isShortcutDisabled('recebiveis')}
            data-testid="shortcut-recebiveis"
          />
          <Shortcut
            to="/atendimento/telemedicina"
            icon={<FaVideo size={32} />}
            label="Telemedicina"
            disabled={isShortcutDisabled('telemedicina')}
            data-testid="shortcut-telemedicina"
          />
        </div>
      </section>

      <section data-testid="activities-section">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <h2 className="font-semibold text-gray-800 mb-4">
              Últimas Atividades
            </h2>
            <div
              className="bg-white p-4 rounded-lg shadow max-h-80 overflow-y-auto focus:outline-none focus:ring-2 focus:ring-primary"
              data-testid="historico-list"
            >
              {historico.length > 0 ? (
                historico.map((item, index) => (
                  <TimelineItem
                    key={index}
                    item={item}
                    data-testid={`historico-item-${index}`}
                  />
                ))
              ) : (
                <div className="text-gray-500">Nenhuma atividade recente.</div>
              )}
            </div>
          </div>

          <div>
            <h2 className="font-semibold text-gray-800 mb-4">
              Próximos Compromissos
            </h2>
            <div
              className="bg-white p-4 rounded-lg shadow max-h-80 overflow-y-auto focus:outline-none focus:ring-2 focus:ring-primary"
              data-testid="pendencias-list"
            >
              <ul className="space-y-4">
                {pendencias.length > 0 ? (
                  pendencias.map((pendencia, index) => (
                    <CompromissoItem
                      key={index}
                      pendencia={pendencia}
                      onEncerrar={handleEncerrar}
                      data-testid={`pendencia-item-${index}`}
                    />
                  ))
                ) : (
                  <li className="text-gray-500">
                    Nenhum compromisso agendado no momento.
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomePage;
